import React from "react";
import { Card, Container, Divider, FormGroup, Link } from "@mui/material";

const Privacy = () => {
  return <Card elevation={0}>
    <FormGroup>
      <p>Privacy Policy of <strong>lessonice.com</strong></p>
      <p><small>Effective Date: 2025/03/07</small></p>
    </FormGroup>
    <FormGroup>
      <p><small>This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website, use our services, or interact with our enterprise solutions. We are committed to protecting your privacy and ensuring that your personal data is handled in compliance with the General Data Protection Regulation (GDPR) and other applicable laws.</small></p>
    </FormGroup>

    <FormGroup><Divider /></FormGroup>

    <FormGroup>
      <p><strong>Owner and Data Collector</strong></p>
      <p><small>
Innomaze FlexCo<br />
Schubertstraße 6a<br/>
8010 Graz<br />
Austria<br /><br />
If you have any questions about this Privacy Policy or your data rights, please contact us at: <Link href="mailto:privacy@lessonice.com">privacy@lessonice.com</Link></small></p>
    </FormGroup>

    <FormGroup><Divider /></FormGroup>
    <FormGroup>
  
  <p><strong>Information We Collect</strong></p>
    <p><small>We collect and process the following categories of personal data:</small></p>
    <br />
<p><small>
<strong>Personal Identifiable Information (PII):</strong> Name, email address, job title, company name.<br />
<strong>Account Information:</strong> Login credentials, user preferences.<br />
<strong>Usage Data:</strong> Information on how you use our services, including IP address, browser type, operating system, and interactions with our platform.<br />
<strong>Billing and Payment Information:</strong> If applicable, we collect payment details to process transactions securely.<br />
<strong>Support and Communication Data:</strong> Any information you provide when contacting customer support.</small></p>
</FormGroup>
<FormGroup><Divider /></FormGroup>

<FormGroup>
<p><strong>Purpose of Data Processing</strong></p>
<p><small>We process your personal data for the following purposes:</small></p>
<br />
<p><small>
To provide and improve our enterprise solutions and services.<br />
To communicate with you, including responding to inquiries and support requests.<br />
To comply with legal obligations, such as tax and accounting requirements.<br />
To monitor and improve security and prevent fraudulent activities.<br />
To personalize user experience and optimize our offerings.<br />
To conduct marketing, where permitted by law, with your explicit consent.</small></p>
</FormGroup>
<FormGroup><Divider /></FormGroup>

<FormGroup>
<p><strong>Legal Basis for Processing</strong></p>
<p><small>We process personal data based on one or more of the following legal grounds:</small></p>
<br />
<p><small>Consent: When you provide explicit consent for specific data processing activities.<br />
Contractual Necessity: When processing is necessary to perform a contract with you.<br />
Legal Obligation: When we are required to comply with a legal obligation.<br />
Legitimate Interest: When processing is necessary for our legitimate business interests, provided it does not override your rights.</small></p>
</FormGroup>
<FormGroup><Divider /></FormGroup>

<FormGroup>
<p><strong>Data Sharing and Disclosure</strong></p>
<p><small>We do not sell your personal data. However, we may share your data with:</small></p>
<br />
<p><small>Service Providers: Third-party vendors who assist in delivering our services (e.g., hosting, payment processing, analytics, customer support).<br />
Legal and Regulatory Authorities: When required to comply with legal obligations.<br />
Business Transfers: In the event of a merger, acquisition, or sale of assets, your data may be transferred.</small></p>
</FormGroup>
<FormGroup><Divider /></FormGroup>

<FormGroup>
<p><strong>International Data Transfers</strong></p>
<p><small>If your data is transferred outside the European Economic Area (EEA), we ensure adequate protection through Standard Contractual Clauses (SCCs) approved by the European Commission.</small></p>
</FormGroup>
<FormGroup><Divider /></FormGroup>

<FormGroup>
<p><strong>Data Retention</strong></p>
<p><small>We retain personal data only as long as necessary to fulfill the purposes outlined in this policy, comply with legal obligations, or resolve disputes.</small></p>
</FormGroup>
<FormGroup><Divider /></FormGroup>

<FormGroup>
<p><strong>Your Rights Under GDPR</strong></p>
<p><small>As a data subject, you have the following rights:</small></p>
<br />
<p><small>Right to Access: Obtain a copy of your personal data.<br />
Right to Rectification: Request correction of inaccurate or incomplete data.<br />
Right to Erasure (Right to be Forgotten): Request deletion of your personal data under certain circumstances.<br />
Right to Restriction of Processing: Request limited processing of your data.<br />
Right to Data Portability: Receive your data in a structured format and transfer it to another controller.<br />
Right to Object: Object to data processing based on legitimate interests or direct marketing.<br />
Right to Withdraw Consent: Withdraw consent at any time where processing is based on consent.<br />
Right to Lodge a Complaint: File a complaint with a supervisory authority if you believe your data rights are violated.</small></p>
<br />
<p><small>To exercise your rights, contact us at <Link href="mailto:privacy@lessonice.com">privacy@lessonice.com</Link>.</small></p>
</FormGroup>
<FormGroup><Divider /></FormGroup>

<FormGroup>
<p><strong>Data Security</strong></p>
<p><small>We implement technical and organizational measures to protect your data from unauthorized access, loss, or misuse, including encryption, access controls, and secure infrastructure.</small></p>
</FormGroup>
<FormGroup><Divider /></FormGroup>

<FormGroup>
<p><strong>Cookies and Tracking Technologies</strong></p>
<p><small>We use cookies and similar tracking technologies to enhance user experience. You can revoke a cookie consent you have already given via your browser settings by deleting all cookies related to this website. You will then be asked for consent again on your next visit.</small></p>
</FormGroup>
<FormGroup><Divider /></FormGroup>

<FormGroup>
<p><strong>Third-Party Links</strong></p>
<p><small>Our services may contain links to third-party websites. We are not responsible for their privacy practices. We encourage reviewing their privacy policies before providing any personal data.</small></p>
</FormGroup>
<FormGroup><Divider /></FormGroup>

<FormGroup>
<p><strong>Changes to This Privacy Policy</strong></p>
<p><small>We may update this Privacy Policy periodically. The latest version will always be available on our website.</small></p>
</FormGroup>
  </Card>;
};

export default Privacy;
